module.exports = __webpack_public_path__ + "static/media/wizard_staff.1f19ede8.png";